export const avatarProperties = ['avatar', 'avatar_sm', 'avatar_md', 'avatar_lg'];

export enum LOGIN_PREFERENCES {
  PASSWORD = 'password',
  SALESFORCE = 'salesforce',
  GOOGLE = 'google'
}

export enum PROFILE_TABS {
  PROFILE = 'PROFILE.PROFILE_TAB',
  SESSIONS = 'PROFILE.SESSIONS_TAB',
  CONNECTED_APPS = 'PROFILE.CONNECTED_APPS_TAB'
}

export enum ACCOUNT_LINK_PROVIDERS {
  GOOGLE = 'google',
  MICROSOFT = 'microsoft'
}

export interface SessionInfo {
  startDate: string;
  ip: string;
  os: {
    name: string;
    version: number[];
    versionString: string;
  };
  browser: {
    name: string;
    version: number[];
    versionString: string;
  };
  device: {
    name: string;
    version: unknown[];
    versionString: string;
  };
  lastActive: string;
  enterprise: string;
  sessionKey: string;
}

export interface Profile {
  canChangeEmail: boolean;
  loginPreferences: [
    LOGIN_PREFERENCES.PASSWORD,
    LOGIN_PREFERENCES.SALESFORCE,
    LOGIN_PREFERENCES.GOOGLE
  ];
  sessions: SessionInfo[];
}

export interface TwoFAStatus {
  enabled: boolean;
  required?: boolean;
  gracePeriod?: Date | null;
}

export interface ImageFile {
  lastModified: number;
  lastModifiedDate: Date;
  name: string;
  size: number;
  type: string;
  webkitRelativePath: string;
}

export interface PersonalDetailsPayload {
  firstName: string;
  lastName: string;
  loginPreference: string;
  locale?: string;
}

export interface McpGrantTeam {
  id: string;
  name: string;
}

export interface McpGrant {
  clientId: string;
  clientName: string;
  clientUri: string | null;
  sessionId: string;
  scopes: Record<string, Record<string, boolean>>;
  allowedTeamIds: string[];
  allowedTeams: McpGrantTeam[];
  activeTeamId: string;
  createdAt: string;
  lastUsedAt: string | null;
  expiresAt: number;
}

export interface AccountLinkError {
  error: string;
  http_code: string;
  status: string;
}
